<template>
<div></div>
</template>

<script>
export default {
name: "forget"
}
</script>

<style scoped lang="scss">

</style>